module.exports = __webpack_public_path__ + "img/take-to-work.1fcfe4a9.jpg";